export type CanonicalTreeEdgeKind =
  | 'parent-child'
  | 'sibling'
  | 'spouse-partner'
  | 'co-parent'
  | 'step-family'
  | 'in-law'
  | 'guardian'
  | 'foster-family'
  | 'chosen-family'
  | 'god-family'
  | 'affiliated-family';

export type CanonicalTreeEdgeDirection =
  | 'directed'
  | 'symmetric'
  | 'child-mediated';

export type CanonicalTreeEdgeStatus =
  | 'active'
  | 'separated'
  | 'divorced'
  | 'ended'
  | 'widowed'
  | 'former'
  | 'historical'
  | 'pending'
  | 'disputed'
  | 'not-applicable';

export type CanonicalTreeEdgeConfirmation =
  | 'confirmed'
  | 'pending'
  | 'disputed'
  | 'rejected';

export type CanonicalTreeEdgeVisibility =
  | 'family'
  | 'private'
  | 'participants';

export type CanonicalTreeEdgeSource =
  | 'parent_ids'
  | 'spouse_id'
  | 'relationship_workflow'
  | 'spouse_partner_edges'
  | 'relationship_history'
  | 'canonical-edge';

export interface CanonicalTreeRelationshipEdge {
  readonly id: string;
  readonly ownerUserId: string | null;

  readonly sourceMemberId: string;
  readonly targetMemberId: string;
  readonly kind: CanonicalTreeEdgeKind;
  readonly direction: CanonicalTreeEdgeDirection;
  readonly status: CanonicalTreeEdgeStatus;

  readonly sharedChildIds: readonly string[];

  readonly createsAncestry: boolean;
  readonly inheritsGeneration: boolean;
  readonly inheritsBranch: boolean;
  readonly inheritsSide: boolean;
  readonly createsInLawship: boolean;
  readonly rendersActivePartnership: boolean;

  readonly affiliatedBranch: boolean;

  readonly startedAt: string | null;
  readonly endedAt: string | null;

  readonly confirmation: CanonicalTreeEdgeConfirmation;
  readonly visibility: CanonicalTreeEdgeVisibility;

  readonly preferredFamilyTitle: string | null;
  readonly source: CanonicalTreeEdgeSource;
  readonly sourceReferenceId: string | null;

  readonly metadata: Readonly<Record<string, unknown>>;
}

export const canonicalTreeEdgePairKey = (
  sourceMemberId: string,
  targetMemberId: string,
): string =>
  sourceMemberId < targetMemberId
    ? `${sourceMemberId}::${targetMemberId}`
    : `${targetMemberId}::${sourceMemberId}`;

export const canonicalTreeEdgeIdentityKey = (
  edge: CanonicalTreeRelationshipEdge,
): string =>
  [
    edge.kind,
    edge.direction,
    edge.sourceMemberId,
    edge.targetMemberId,
    edge.status,
    edge.startedAt ?? '',
    edge.endedAt ?? '',
    [...edge.sharedChildIds].sort().join(','),
  ].join('|');
